<div
  class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between"
>
  <h5 class="mb-0">Profissionais</h5>
  <ol class="breadcrumb mb-0 ps-0">
    <li class="breadcrumb-item">
      <a routerLink="/">
        <i class="ri-home-8-line"></i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item fw-semibold">Profissionais</li>
  </ol>
</div>

<mat-card class="mb-25 tagus-card">
  <mat-card-content>
    <div class="d-flex">
      <div class="tagus-form-group w-100">
        <mat-form-field appearance="fill">
          <i class="ri-search-line"></i>
          <mat-label>Filtrar</mat-label>
          <input matInput (keyup)="applyFilter($event)" #input />
        </mat-form-field>
      </div>
      <div>
        <button mat-icon-button (click)="getAll()">
          <mat-icon>update</mat-icon>
        </button>
      </div>
    </div>
    <div class="mat-elevation-z8 tagus-mat-table">
      <div *ngIf="isLoading" class="skeleton-table">
        <div class="skeleton-header">
          <div class="skeleton-cell skeleton-cell--sm"></div>
          <div class="skeleton-cell skeleton-cell--lg"></div>
          <div class="skeleton-cell skeleton-cell--md"></div>
          <div class="skeleton-cell skeleton-cell--xl"></div>
          <div class="skeleton-cell skeleton-cell--sm"></div>
          <div class="skeleton-cell skeleton-cell--md"></div>
          <div class="skeleton-cell skeleton-cell--sm"></div>
          <div class="skeleton-cell skeleton-cell--sm"></div>
        </div>
        <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8]">
          <div class="skeleton-cell skeleton-cell--avatar shimmer"></div>
          <div class="skeleton-cell skeleton-cell--lg shimmer"></div>
          <div class="skeleton-cell skeleton-cell--md shimmer"></div>
          <div class="skeleton-cell skeleton-cell--xl shimmer"></div>
          <div class="skeleton-cell skeleton-cell--sm shimmer"></div>
          <div class="skeleton-cell skeleton-cell--md shimmer"></div>
          <div class="skeleton-cell skeleton-cell--sm shimmer"></div>
          <div class="skeleton-cell skeleton-cell--sm shimmer"></div>
        </div>
      </div>

      <table mat-table [dataSource]="dataSource" [class.d-none]="isLoading">
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Ação</th>
          <td mat-cell *matCellDef="let element">
            <button
              type="button"
              mat-button
              class="position-relative dot-btn p-0 bg-transparent border-none"
              [matMenuTriggerFor]="actionMenu"
            >
              <i class="{{ element.action }}"></i>
            </button>
            <mat-menu
              #actionMenu="matMenu"
              class="dotMenu two monthMenu"
              xPosition="before"
            >
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="action(element.id, 'APPROVED')"
                *ngIf="
                  element.status === 'PENDING' || element.status === 'REJECTED'
                "
              >
                <i class="ri-check-line"></i>
                Ativar Cadastro
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="action(element.id, 'REJECTED')"
                *ngIf="
                  element.status === 'PENDING' || element.status === 'APPROVED'
                "
              >
                <i class="ri-spam-2-fill"></i>
                Rejeitar Cadastro
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="goToUserEdit(element.id)"
              >
                <i class="ri-edit-line"></i> Visualizar/Editar
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="downloadRegisterForm(element.id, element.name)"
              >
                <i class="ri-file-text-line"></i> Exportar ficha cadastral
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="goToScale(element.id)"
              >
                <i class="ri-calendar-fill"></i> Escala
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="changePassword(element.id, element.name)"
              >
                <i class="ri-lock-password-fill"></i> Alterar senha
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="viewHistory(element.id, element.name)"
              >
                <i class="ri-list-ordered"></i> Histórico
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="deleteById(element.id)"
              >
                <i class="ri-delete-bin-line"></i> Excluir
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="toggleActive(element.id, element.isActive)"
              >
                <i [class]="element.isActive ? 'ri-forbid-line' : 'ri-restart-line'"></i>
                {{ element.isActive ? 'Desativar' : 'Ativar' }}
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <img
              [src]="getPhotoSrc(element.id)"
              (error)="$any($event.target).src='assets/img/user/user1.jpg'"
              (click)="openPhotoPreview(element.id); $event.stopPropagation()"
              alt="{{ element.name }}"
              class="border-radius photo-thumb"
              width="40"
              height="40"
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
          <td mat-cell *matCellDef="let element" class="text-left">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="document">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>CPF</th>
          <td mat-cell *matCellDef="let element">{{ element.document }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <ng-container matColumnDef="licenseNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº Licença</th>
          <td mat-cell *matCellDef="let element">
            {{ element.licenseNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cellphone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº Celular</th>
          <td mat-cell *matCellDef="let element">{{ element.cellphone }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ getNameStatus(element.status) }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            Não foram encontradas informações.
          </td>
        </tr>
      </table>
      <mat-paginator
        [length]="totalProfessionals"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)"
        showFirstLastButtons
        aria-label="Selecione a página"
      ></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>

<div class="photo-preview-overlay" *ngIf="previewPhotoSrc" (click)="closePhotoPreview()">
  <div class="photo-preview-modal" (click)="$event.stopPropagation()">
    <button class="photo-preview-close" (click)="closePhotoPreview()">
      <i class="ri-close-line"></i>
    </button>
    <img
      [src]="previewPhotoSrc"
      (error)="$any($event.target).src='assets/img/user/user1.jpg'"
      alt="Preview"
      class="photo-preview-img"
    />
  </div>
</div>
